import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

export function TrendBadge({ value, size = 'sm' }) {
  if (value == null || isNaN(value)) return null;
  const num = Number(value);
  const iconSize = size === 'sm' ? 10 : 12;

  if (Math.abs(num) < 0.1) {
    return (
      <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-[11px] font-semibold bg-gray-100 text-gray-500">
        <Minus size={iconSize} /> 0.0%
      </span>
    );
  }

  return (
    <span className={num >= 0 ? 'metric-badge-up' : 'metric-badge-down'}>
      {num >= 0 ? <TrendingUp size={iconSize} /> : <TrendingDown size={iconSize} />}
      {num >= 0 ? '+' : ''}{num.toFixed(1)}%
    </span>
  );
}
